export default {
    partnersByType(state) {
        return state.partnersByType;
    },
    loadingPartners(state) {
        return state.loadingPartners;
    },
    editingPartner(state) {
        return state.editingPartner;
    },
    errors(state) {
        return state.errors;
    }
}